import {
  GET_CATEGORIES,
  SHOW_IMAGE_VIEWER,
  HIDE_IMAGE_VIEWER,
  SET_IMAGE_VIEWER_DATA,
} from './types';

export default {
  [GET_CATEGORIES]: (state, categories) => {
    state.categories = categories;
  },

  [SET_IMAGE_VIEWER_DATA]: (state, { attachments, initialSlideNumber}) => {
    state.imageViewer = {
      attachments,
      initialSlideNumber,
    };
  },

  [SHOW_IMAGE_VIEWER]: (state) => {
    state.showImageViewer = true;
  },

  [HIDE_IMAGE_VIEWER]: (state) => {
    state.showImageViewer = false;
  },
};
